import {createI18n, I18n} from 'vue-i18n';

export function translationsFromAttribute(element: Element, attributeName: string): I18n {
    return createI18n({
        locale: 'default',
        legacy: false,
        messages: {
            default: JSON.parse(element.getAttribute(attributeName) || '{}'),
        },
    });
}
